<template>
  <v-expansion-panels :value="indexOpen" hover>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <span class="font-weight-medium">Justficantes registrados</span>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <div style="overflow: auto">
          <v-data-table
            :headers="headerJusti"
            :items="justificantes"
            dense
            :items-per-page="5"
            :hide-default-footer="hideFooterJusti"
            :footer-props="footerProps"
            :loading="loadingJusti"
            loading-text="Cargando datos..."
          >
            <template v-slot:item.estatus="{ item }">
              <v-chip :color="item.color" :text-color="item.fontColor" small>
                {{ item.estatus }}
              </v-chip>
            </template>
            <template v-slot:item.vigenciaIni="{ item }">
              {{ formatFec(item.vigenciaIni) }}
            </template>
            <template v-slot:item.vigenciaFin="{ item }">
              {{ formatFec(item.vigenciaFin) }}
            </template>
          </v-data-table>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <span class="font-weight-medium">Vacaciones pendientes de disfrutar (días)</span>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-data-table
          :headers="headerPeriodo"
          :items="periodosVac"
          dense
          hide-default-footer
          :loading="loadingVac"
          loading-text="Cargando datos..."
        >
          <template v-slot:item.diasPer1="{ item }">
            <span v-if="item.diasPer1 < item.disfPer1" class="red--text" > {{ diasPendientes(item, "1") }} </span>
            <span v-else> {{ diasPendientes(item, "1") }} </span>
          </template>
          <template v-slot:item.diasPer2="{ item }">
            <span v-if="item.diasPer2 < item.disfPer2" class="red--text" > {{ diasPendientes(item, "2") }} </span>
            <span v-else> {{ diasPendientes(item, "2") }} </span>
          </template>
          <template v-slot:item.diasExtra="{ item }">
            {{ diasPendientes(item, "extra") }}
          </template>
        </v-data-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <span class="font-weight-medium">Vacaciones registradas</span>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-data-table
          :headers="headerVac"
          :items="vacaciones"
          dense
          :items-per-page="5"
          :hide-default-footer="hideFooterVac"
          :footer-props="footerProps"
          :loading="loadingVac"
          loading-text="Cargando datos..."
        >
          <template v-slot:item.vigenciaIni="{ item }">
            {{ formatFec(item.vigenciaIni) }}
          </template>
          <template v-slot:item.vigenciaFin="{ item }">
            {{ formatFec(item.vigenciaFin) }}
          </template>
          <template v-slot:item.estatus="{ item }">
            <v-chip :color="item.color" :text-color="item.fontColor" small>
              {{ item.estatus }}
            </v-chip>
          </template>
        </v-data-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
  props: {
    numEmpleado: {
      type: Number,
      required: true
    },
    reload: {
      type: Boolean,
      required: true
    },
    modo: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      headerJusti: [
        { text: 'Justificante', value: 'justificante', class: "accent white--text"},
        { text: 'Del', value: 'vigenciaIni', class: "accent white--text"},
        { text: 'Al', value: 'vigenciaFin', class: "accent white--text"},
        { text: 'Estatus', value: 'estatus', class: "accent white--text"},
        { text: 'Rango', value: 'rango', class: "accent white--text"}
      ],
      headerVac: [
        { text: 'Ejercicio', value: 'ejercicio', class: "accent white--text"},
        { text: 'Periodo', value: 'periodo', class: "accent white--text"},
        { text: 'Del', value: 'vigenciaIni', class: "accent white--text"},
        { text: 'Al', value: 'vigenciaFin', class: "accent white--text"},
        { text: 'Dias', value: 'dias', class: "accent white--text"},
        { text: 'Estatus', value: 'estatus', class: "accent white--text"}
      ],
      headerPeriodo: [
        { text: 'Ejercicio', value: 'ejercicio', class: "accent white--text"},
        { text: '1er. Periodo', value: 'diasPer1', class: "accent white--text"},
        { text: '2o. Periodo', value: 'diasPer2', class: "accent white--text"},
        { text: 'Extra', value: 'diasExtra', class: "accent white--text"}
      ],
      footerProps: {
        disableItemsPerPage: true,
      },
      justificantes: [],
      vacaciones: [],
      periodosVac: [],
      loadingJusti: false,
      loadingVac: false,
      loadingPer: false,
      indexOpen: 0
    }
  },
  watch: {
    numEmpleado() {
      if (this.numEmpleado > 0) {
        this.loadJustificantes(this.numEmpleado);
      } else {
        this.justificantes = [];
        this.vacaciones = [];
        this.periodosVac = [];
      }
    },
    reload() {
      if (this.reload) {
        this.loadJustificantes(this.numEmpleado);
      }
    }
  },
  computed: {
    hideFooterJusti() {
      return this.justificantes.length < 6;
    },
    hideFooterVac() {
      return this.vacaciones.length < 6;
    },
    ...mapState(["token"]),
  },
  methods: {
    async loadJustificantes(numEmpleado) {
      this.loadingJusti = true;
      this.justificantes = [];
      this.vacaciones = [];
      this.periodosVac = [];
      try {
        let response = await axios.get(`/justificante/${numEmpleado}`);
        this.justificantes = response.data;
        this.loadingJusti = false;
        this.loadingVac = true;
        this.loadingPer = true;
        response = await axios.get(`/justificante/vacaciones/${numEmpleado}?modo=${this.modo}`);
        this.vacaciones = response.data.vacaciones;
        this.periodosVac = response.data.periodos;
        if (this.vacaciones && this.vacaciones.length > 0) {
          const vacs = this.vacaciones.map(v => {
            const vc = {...v};
            vc.vigenciaIni = v.vigenciaIni.substring(0, 10)+ 'T10'+ v.vigenciaIni.substring(13);
            vc.vigenciaFin = v.vigenciaFin.substring(0, 10)+ 'T10'+ v.vigenciaFin.substring(13);
            return vc;
          });
          this.vacaciones = vacs;
        }
        this.sendInfoEmp();
      }catch(error) {
        if (error.response) {
          console.log(error.response);
        } else {
          console.log(error);
        }
      }
      finally {
        this.loadingJusti = false;
        this.loadingVac = false;
        this.loadingPer = false;
      }
    },
    formatFec(fecha) {
      if (!fecha) return ""
      const [year, month, day] = fecha.substr(0,10).split('-');
      return `${day}/${month}/${year}`
    },
    diasPendientes(item, periodo) {
      let dias;
      if (periodo === "1")
        dias = item.diasPer1- item.disfPer1;
      else if (periodo === "2")
        dias = item.diasPer2- item.disfPer2;
      else
        dias = item.diasExtra- item.disfExtra;
      return dias;
    },
    sendInfoEmp() {
      let datos = {
        justificantes: this.justificantes,
        periodosVac: this.periodosVac,
        vacaciones: this.vacaciones
      }
      this.$emit("info-emp", datos);
    }
  },
  mounted() {
    if (this.numEmpleado > 0) {
      this.loadJustificantes(this.numEmpleado);
    }
  }
};
</script>